import { jsx as _jsx } from "react/jsx-runtime";
import { createTheme } from '@mui/material/styles';
import CustomChecboxIcon from './custom-icons/checkbox-icon';
import CustomChecboxCheckedIcon from './custom-icons/checkbox-checked-icon';
import ChecboxIcon from './custom-icons/check-icon';
import CheckEmptyIcon from './custom-icons/check-empty-icon';
const CustomTheme = createTheme({
    typography: {
        fontFamily: ['Lato', 'sans-serif'].join(','),
    },
    palette: {
        primary: {
            main: '#00964B',
        }
    },
    components: {
        MuiCheckbox: {
            defaultProps: {
                icon: _jsx(CustomChecboxIcon, {}),
                checkedIcon: _jsx(CustomChecboxCheckedIcon, {})
            }
        },
        MuiRadio: {
            defaultProps: {
                icon: _jsx(CheckEmptyIcon, {}),
                checkedIcon: _jsx(ChecboxIcon, {})
            }
        },
        MuiTooltip: {
            styleOverrides: {
                tooltipPlacementRight: {
                    backgroundColor: '#E6E9ED',
                    padding: "16px",
                    width: '360px',
                    borderRadius: '24px',
                    top: '-20px',
                    span: {
                        color: '#E6E9ED',
                        top: '20px !important'
                    }
                },
            }
        },
        MuiSkeleton: {
            styleOverrides: {
                wave: {
                    "::after": {
                        background: 'linear-gradient(90deg,transparent,white,transparent)'
                    }
                }
            }
        }
    }
});
export default CustomTheme;
